/**
 * 其他语言标准库列表
 * 包含: Java, Rust, Ruby, PHP, C, C++, Kotlin, Swift, C#
 * 数据来源: hallucination.ts
 */

// ==================== Java标准库（常用包） ====================
export const JAVA_STDLIB: ReadonlySet<string> = new Set([
  "java.lang",
  "java.util",
  "java.io",
  "java.net",
  "java.nio",
  "java.nio.file",
  "java.nio.charset",
  "java.math",
  "java.time",
  "java.time.format",
  "java.time.temporal",
  "java.time.zone",
  "java.text",
  "java.util.stream",
  "java.util.function",
  "java.util.concurrent",
  "java.util.concurrent.atomic",
  "java.util.concurrent.locks",
  "java.util.regex",
  "java.util.logging",
  "java.util.zip",
  "java.util.jar",
  "java.util.prefs",
  "java.util.random",
  "java.util.spi",
  "java.lang.reflect",
  "java.lang.annotation",
  "java.lang.invoke",
  "java.lang.module",
  "java.lang.ref",
  "java.lang.runtime",
  "java.io",
  "java.io.file",
  "java.io.stream",
  "java.net.http",
  "java.net.ssl",
  "java.net.URI",
  "java.net.URL",
  "java.net.InetAddress",
  "java.net.ServerSocket",
  "java.net.Socket",
  "java.net.DatagramSocket",
  "java.security",
  "java.security.cert",
  "java.security.spec",
  "java.security.KeyStore",
  "java.security.MessageDigest",
  "java.security.Signature",
  "java.security.SecureRandom",
  "javax.crypto",
  "javax.crypto.spec",
  "javax.crypto.Cipher",
  "javax.crypto.Mac",
  "javax.crypto.SecretKey",
  "javax.crypto.KeyGenerator",
  "javax.net.ssl",
  "javax.security.auth",
  "javax.sql",
  "javax.xml.parsers",
  "javax.xml.transform",
  "javax.xml.transform.stream",
  "javax.xml.transform.dom",
  "javax.xml.bind",
  "javax.json",
  "javax.swing",
  "javax.awt",
  "java.awt",
  "java.awt.event",
  "java.awt.image",
  "java.applet",
  "java.beans",
  "java.rmi",
  "java.rmi.server",
  "java.sql",
  "java.sql.ResultSet",
  "java.sql.Connection",
  "java.sql.PreparedStatement",
  "java.sql.Statement",
  "java.sql.DriverManager",
  "javax.naming",
  "javax.naming.directory",
  "javax.management",
  "javax.management.remote",
  "org.w3c.dom",
  "org.xml.sax",
  "org.xml.sax.helpers",
]);

// ==================== Rust标准库（常用crate） ====================
export const RUST_STDLIB: ReadonlySet<string> = new Set([
  "std",
  "std::collections",
  "std::collections::HashMap",
  "std::collections::HashSet",
  "std::collections::BTreeMap",
  "std::collections::BTreeSet",
  "std::collections::VecDeque",
  "std::collections::LinkedList",
  "std::collections::BinaryHeap",
  "std::sync",
  "std::sync::Arc",
  "std::sync::Mutex",
  "std::sync::RwLock",
  "std::sync::mpsc",
  "std::sync::atomic",
  "std::sync::Barrier",
  "std::sync::Condvar",
  "std::sync::Once",
  "std::sync::LazyLock",
  "std::sync::OnceLock",
  "std::thread",
  "std::thread::JoinHandle",
  "std::fs",
  "std::fs::File",
  "std::fs::DirBuilder",
  "std::fs::OpenOptions",
  "std::io",
  "std::io::Read",
  "std::io::Write",
  "std::io::BufRead",
  "std::io::BufReader",
  "std::io::BufWriter",
  "std::io::Cursor",
  "std::io::Error",
  "std::io::ErrorKind",
  "std::io::Stdin",
  "std::io::Stdout",
  "std::io::stderr",
  "std::net",
  "std::net::TcpListener",
  "std::net::TcpStream",
  "std::net::UdpSocket",
  "std::net::IpAddr",
  "std::net::Ipv4Addr",
  "std::net::Ipv6Addr",
  "std::net::SocketAddr",
  "std::path",
  "std::path::Path",
  "std::path::PathBuf",
  "std::env",
  "std::env::Args",
  "std::env::Vars",
  "std::process",
  "std::process::Command",
  "std::process::Stdio",
  "std::process::Child",
  "std::process::ExitStatus",
  "std::time",
  "std::time::Duration",
  "std::time::Instant",
  "std::time::SystemTime",
  "std::fmt",
  "std::fmt::Display",
  "std::fmt::Debug",
  "std::fmt::Formatter",
  "std::fmt::Result",
  "std::str",
  "std::str::FromStr",
  "std::str::Split",
  "std::string",
  "std::string::String",
  "std::vec",
  "std::vec::Vec",
  "std::option",
  "std::option::Option",
  "std::result",
  "std::result::Result",
  "std::boxed",
  "std::boxed::Box",
  "std::rc",
  "std::rc::Rc",
  "std::cell",
  "std::cell::RefCell",
  "std::cell::Cell",
  "std::convert",
  "std::convert::From",
  "std::convert::Into",
  "std::convert::TryFrom",
  "std::convert::TryInto",
  "std::convert::AsRef",
  "std::convert::AsMut",
  "std::iter",
  "std::iter::Iterator",
  "std::iter::IntoIterator",
  "std::iter::FromIterator",
  "std::iter::Map",
  "std::iter::Filter",
  "std::iter::Chain",
  "std::iter::Zip",
  "std::iter::Enumerate",
  "std::ops",
  "std::ops::Range",
  "std::ops::RangeInclusive",
  "std::ops::Deref",
  "std::ops::DerefMut",
  "std::ops::Fn",
  "std::ops::FnMut",
  "std::ops::FnOnce",
  "std::cmp",
  "std::cmp::Ordering",
  "std::cmp::PartialEq",
  "std::cmp::PartialOrd",
  "std::cmp::Eq",
  "std::cmp::Ord",
  "std::hash",
  "std::hash::Hash",
  "std::hash::Hasher",
  "std::hash::BuildHasher",
  "std::any",
  "std::any::Any",
  "std::any::TypeId",
  "std::any::type_name",
  "std::marker",
  "std::marker::PhantomData",
  "std::marker::Send",
  "std::marker::Sync",
  "std::marker::Sized",
  "std::marker::Copy",
  "std::marker::Clone",
  "std::mem",
  "std::ptr",
  "std::ffi",
  "std::ffi::CString",
  "std::ffi::CStr",
  "std::ffi::OsString",
  "std::ffi::OsStr",
  "std::os",
  "std::os::unix",
  "std::os::unix::fs",
  "std::os::unix::net",
  "std::os::unix::process",
  "std::os::windows",
  "std::os::windows::fs",
  "std::os::windows::io",
  "std::error",
  "std::error::Error",
  "std::panic",
  "std::backtrace",
  "std::task",
  "std::task::Poll",
  "std::task::Context",
  "std::future",
  "std::future::Future",
  "std::pin",
  "std::pin::Pin",
  "core",
  "alloc",
  "proc_macro",
  "test",
]);

// ==================== Ruby标准库（常用模块） ====================
export const RUBY_STDLIB: ReadonlySet<string> = new Set([
  "csv",
  "digest",
  "drb",
  "erb",
  "fileutils",
  "find",
  "forwardable",
  "io/console",
  "ipaddr",
  "json",
  "logger",
  "monitor",
  "net/http",
  "net/https",
  "net/ftp",
  "net/smtp",
  "net/pop",
  "net/imap",
  "net/telnet",
  "objspace",
  "open3",
  "open-uri",
  "optparse",
  "ostruct",
  "pathname",
  "pp",
  "prettyprint",
  "prime",
  "pstore",
  "psych",
  "racc",
  "rake",
  "rdoc",
  "resolv",
  "rexml",
  "rss",
  "rubygems",
  "securerandom",
  "set",
  "shellwords",
  "singleton",
  "socket",
  "stringio",
  "strscan",
  "syslog",
  "tempfile",
  "thread",
  "timeout",
  "tmpdir",
  "tracer",
  "tsort",
  "uri",
  "weakref",
  "yaml",
  "zlib",
  "bigdecimal",
  "cgi",
  "cmath",
  "coverage",
  "date",
  "dbm",
  "delegate",
  "did_you_mean",
  "digest/md5",
  "digest/sha1",
  "digest/sha2",
  "etc",
  "fcntl",
  "fiddle",
  "gdbm",
  "getoptlong",
  "io/nonblock",
  "io/wait",
  "irb",
  "json",
  "kconv",
  "nkf",
  "observer",
  "open-uri",
  "openssl",
  "optionparser",
  "pathname",
  "pty",
  "readline",
  "rexml/document",
  "ripper",
  "sdbm",
  "socket",
  "stringio",
  "strscan",
  "syslog/logger",
  "tempfile",
  "time",
  "timeout",
  "tracer",
  "un",
  "unicode_normalize",
  "uri",
  "win32ole",
  "yaml",
  "zlib",
]);

// ==================== PHP标准库（常用扩展/函数命名空间） ====================
export const PHP_STDLIB: ReadonlySet<string> = new Set([
  // Core
  "Core",
  "standard",
  "SPL",
  "Reflection",
  // Common extensions
  "curl",
  "date",
  "dom",
  "fileinfo",
  "filter",
  "hash",
  "iconv",
  "json",
  "libxml",
  "mbstring",
  "mysqlnd",
  "openssl",
  "pcre",
  "PDO",
  "pdo_mysql",
  "pdo_pgsql",
  "pdo_sqlite",
  "pgsql",
  "Phar",
  "posix",
  "random",
  "readline",
  "redis",
  "session",
  "SimpleXML",
  "soap",
  "sockets",
  "sodium",
  "sqlite3",
  "tokenizer",
  "xml",
  "xmlreader",
  "xmlwriter",
  "xsl",
  "zip",
  "zlib",
  // Built-in interfaces/classes
  "ArrayAccess",
  "ArrayObject",
  "Closure",
  "Countable",
  "DirectoryIterator",
  "DomainException",
  "ErrorException",
  "Exception",
  "FilesystemIterator",
  "FilterIterator",
  "GlobIterator",
  "InvalidArgumentException",
  "Iterator",
  "IteratorAggregate",
  "LengthException",
  "LogicException",
  "OutOfBoundsException",
  "OutOfRangeException",
  "OverflowException",
  "PDOException",
  "RangeException",
  "RecursiveArrayIterator",
  "RecursiveDirectoryIterator",
  "RecursiveIteratorIterator",
  "RuntimeException",
  "SeekableIterator",
  "Serializable",
  "SplFixedArray",
  "SplHeap",
  "SplMaxHeap",
  "SplMinHeap",
  "SplObjectStorage",
  "SplPriorityQueue",
  "SplQueue",
  "SplStack",
  "Traversable",
  "UnderflowException",
  "UnexpectedValueException",
]);

// ==================== C标准库头文件 ====================
export const C_STDLIB: ReadonlySet<string> = new Set([
  "stdio.h",
  "stdlib.h",
  "string.h",
  "math.h",
  "time.h",
  "ctype.h",
  "errno.h",
  "signal.h",
  "assert.h",
  "stddef.h",
  "stdbool.h",
  "stdint.h",
  "inttypes.h",
  "limits.h",
  "float.h",
  "locale.h",
  "setjmp.h",
  "stdarg.h",
  "complex.h",
  "fenv.h",
  "tgmath.h",
  "wchar.h",
  "wctype.h",
  "iso646.h",
]);

// ==================== C++标准库头文件 ====================
export const CPP_STDLIB: ReadonlySet<string> = new Set([
  // C++ headers (no .h)
  "algorithm",
  "array",
  "atomic",
  "bitset",
  "chrono",
  "codecvt",
  "compare",
  "complex",
  "concepts",
  "condition_variable",
  "coroutine",
  "deque",
  "exception",
  "execution",
  "filesystem",
  "format",
  "forward_list",
  "fstream",
  "functional",
  "future",
  "initializer_list",
  "iomanip",
  "ios",
  "iosfwd",
  "iostream",
  "istream",
  "iterator",
  "limits",
  "list",
  "locale",
  "map",
  "memory",
  "memory_resource",
  "mutex",
  "new",
  "numbers",
  "numeric",
  "optional",
  "ostream",
  "queue",
  "random",
  "ranges",
  "ratio",
  "regex",
  "scoped_allocator",
  "set",
  "shared_mutex",
  "source_location",
  "span",
  "sstream",
  "stack",
  "stdexcept",
  "stop_token",
  "streambuf",
  "string",
  "string_view",
  "strstream",
  "syncstream",
  "system_error",
  "thread",
  "tuple",
  "type_traits",
  "typeindex",
  "typeinfo",
  "unordered_map",
  "unordered_set",
  "utility",
  "valarray",
  "variant",
  "vector",
  "version",
  // C++ C compatibility headers
  "cassert",
  "ccomplex",
  "cctype",
  "cerrno",
  "cfenv",
  "cfloat",
  "cinttypes",
  "ciso646",
  "climits",
  "clocale",
  "cmath",
  "csetjmp",
  "csignal",
  "cstdalign",
  "cstdarg",
  "cstdbool",
  "cstddef",
  "cstdint",
  "cstdio",
  "cstdlib",
  "cstring",
  "ctgmath",
  "ctime",
  "cuchar",
  "cwchar",
  "cwctype",
]);

// ==================== Kotlin标准库 ====================
export const KOTLIN_STDLIB: ReadonlySet<string> = new Set([
  "kotlin",
  "kotlin.collections",
  "kotlin.comparisons",
  "kotlin.io",
  "kotlin.ranges",
  "kotlin.sequences",
  "kotlin.text",
  "kotlin.math",
  "kotlin.concurrent",
  "kotlin.properties",
  "kotlin.reflect",
  "kotlin.coroutines",
  "kotlin.streams",
  "kotlin.time",
  "kotlin.random",
  "kotlin.system",
  "kotlin.js",
  "kotlin.native",
  "kotlin.jvm",
  "kotlin.annotation",
  "kotlin.enums",
  "kotlin.experimental",
  "kotlin.internal",
  "kotlin.coroutines.intrinsics",
  "kotlin.coroutines.jvm.internal",
  "kotlinx",
  "kotlinx.coroutines",
  "kotlinx.coroutines.flow",
  "kotlinx.coroutines.sync",
  "kotlinx.coroutines.channels",
  "kotlinx.coroutines.select",
  "kotlinx.serialization",
  "kotlinx.serialization.json",
  "kotlinx.serialization.protobuf",
  "kotlinx.serialization.cbor",
  "kotlinx.serialization.properties",
]);

// ==================== Swift标准库 ====================
export const SWIFT_STDLIB: ReadonlySet<string> = new Set([
  "Swift",
  "Foundation",
  "FoundationNetworking",
  "FoundationXML",
  "Combine",
  "Concurrency",
  "Observation",
  "SwiftUI",
  "UIKit",
  "AppKit",
  "CoreData",
  "CoreFoundation",
  "CoreGraphics",
  "CoreImage",
  "CoreLocation",
  "CoreServices",
  "CoreText",
  "CoreVideo",
  "CryptoKit",
  "GameKit",
  "MapKit",
  "Network",
  "Photos",
  "PhotosUI",
  "Security",
  "StoreKit",
  "WebKit",
  "XCTest",
  "SwiftData",
  "WidgetKit",
  "CloudKit",
  "AVFoundation",
  "CoreAudio",
  "CoreAnimation",
  "CoreMedia",
  "CoreMIDI",
  "Metal",
  "MetalKit",
  "MetalPerformanceShaders",
  "SceneKit",
  "SpriteKit",
  "Vision",
  "NaturalLanguage",
  "Speech",
  "CoreML",
  "CreateML",
  "ActivityKit",
  "BackgroundTasks",
  "UserNotifications",
  "OSLog",
  "System",
  "RegexBuilder",
  "Charts",
]);

// ==================== C#标准库命名空间 ====================
export const CSHARP_STDLIB: ReadonlySet<string> = new Set([
  "System",
  "System.Collections",
  "System.Collections.Generic",
  "System.Collections.Concurrent",
  "System.Collections.Specialized",
  "System.IO",
  "System.IO.Compression",
  "System.IO.Pipes",
  "System.IO.Ports",
  "System.IO.FileSystem",
  "System.IO.IsolatedStorage",
  "System.Net",
  "System.Net.Http",
  "System.Net.Sockets",
  "System.Net.Mail",
  "System.Net.NetworkInformation",
  "System.Net.Security",
  "System.Net.WebSockets",
  "System.Text",
  "System.Text.Json",
  "System.Text.RegularExpressions",
  "System.Text.Encodings",
  "System.Threading",
  "System.Threading.Tasks",
  "System.Threading.Channels",
  "System.Threading.Tasks.Dataflow",
  "System.Linq",
  "System.Linq.Expressions",
  "System.Reflection",
  "System.Reflection.Emit",
  "System.Reflection.Metadata",
  "System.Runtime",
  "System.Runtime.CompilerServices",
  "System.Runtime.InteropServices",
  "System.Runtime.Serialization",
  "System.Runtime.Versioning",
  "System.Security",
  "System.Security.Cryptography",
  "System.Security.Authentication",
  "System.Security.Claims",
  "System.Security.Permissions",
  "System.Security.Principal",
  "System.Diagnostics",
  "System.Diagnostics.CodeAnalysis",
  "System.Diagnostics.Contracts",
  "System.Diagnostics.Process",
  "System.Diagnostics.Tracing",
  "System.Globalization",
  "System.Resources",
  "System.Math",
  "System.Convert",
  "System.DateTime",
  "System.TimeSpan",
  "System.Guid",
  "System.String",
  "System.MathF",
  "System.Environment",
  "System.Console",
  "System.Random",
  "System.Convert",
  "System.BitConverter",
  "System.Buffer",
  "System.Span",
  "System.Memory",
  "System.Buffers",
  "System.Numerics",
  "System.Formats",
  "System.Formats.Asn1",
  "System.Formats.Tar",
  "System.CodeDom",
  "System.ComponentModel",
  "System.Data",
  "System.Data.Common",
  "System.Data.SqlClient",
  "System.Xml",
  "System.Xml.Linq",
  "System.Xml.Serialization",
  "System.Xml.XPath",
  "System.Xml.Xsl",
  "System.Json",
  "System.Timers",
  "System.Type",
  "System.Object",
  "System.Boolean",
  "System.Byte",
  "System.SByte",
  "System.Int16",
  "System.Int32",
  "System.Int64",
  "System.UInt16",
  "System.UInt32",
  "System.UInt64",
  "System.Single",
  "System.Double",
  "System.Decimal",
  "System.Char",
  "System.Void",
  "System.Array",
  "System.Exception",
  "System.Action",
  "System.Func",
  "System.Predicate",
  "System.Comparison",
  "System.EventHandler",
  "System.EventArgs",
  "System.IAsyncResult",
  "System.IDisposable",
  "System.IComparable",
  "System.IEquatable",
  "System.IFormatProvider",
  "System.ICloneable",
  "System.Collections.IEnumerable",
  "System.Collections.IEnumerator",
  "System.Collections.IList",
  "System.Collections.IDictionary",
  "System.Collections.ICollection",
  "Microsoft",
  "Microsoft.CSharp",
  "Microsoft.VisualBasic",
  "Microsoft.Win32",
]);
